import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { align: "left" }
const _hoisted_2 = { style: {"height":"800px"} }
const _hoisted_3 = { class: "dialog-footer" }

import { nextTick, reactive, ref } from "vue";
import { useRouter } from "vue-router";
import {ElLoading, ElMessage, ElMessageBox, ElNotification} from "element-plus";
import { getLibraryGenerateUrl } from "@/service/main/promotion/libraryGenerate";
import useClipboard from "vue-clipboard3";
import { deletePageData, editPageData, getPageListData } from "@/service/main/system";
import { usePermission } from "@/hooks/usePermission";
import store from "@/store";
import { modalConfig } from "./config/modal.config";
import { usePageModal } from "@/hooks/usePageModal";
import { useUpload } from "@/hooks/useUpload";

const pageName = 'materialLibrary';

export default /*#__PURE__*/_defineComponent({
  __name: 'MindmapManage',
  setup(__props) {

const treeRef = ref();
const keyword = ref('');
const nodes = ref('');
const initData = ()=> {
  getPageListData('/main/materialLibrary/listTree', null).then(
    (res)=> {
      // let empNo = store.state.login.userInfo.empNo;
      // let authArr = ['zhuye', 'kongyuelian', '90000', '440091', '430175', '10846', 'fanlongxi', '10001', 'suntao', 'lifuz', '401863', '440110'];
      // let auth = authArr.includes(empNo);
      // if (!auth) {
      //   res.children[2].children[2].children.splice(8);
      //   res.children[1].children.splice(6);
      // }
      nodes.value = res;
      getTree();
    });
}
initData();

const { toClipboard } = useClipboard()

const drawer = ref(false)
const direction = ref('rtl')

const draggable = ref(true);
const materials = ref([])
const drawerTitle = ref(String)
const nodeDbclick = (e: any, data: any)=> {
  data.focused = true;
}
const nodeDragEnd = (sourceNode: any, targetNode: any)=> {
  editPageData('/main/materialLibrary/node/drag/'+sourceNode.id+'/'+targetNode.id, null);
}
const beforeDragEnd = async (curNode: any)=> {
  await ElMessageBox.confirm('确定要移动吗？（<font color="red">将会同时移动所有子分支</font>）',
    '注意',
    {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning',
      dangerouslyUseHTMLString: true
    }
  ).then(()=> {
    return new Promise((resolve: any, reject:any) => {
      resolve();
    })
  }).catch(()=> {
    return new Promise((resolve: any, reject:any) => {
      reject();
    })
  });
}
const nodeDrag = (curNode: any)=> {
}
const nodeDragStart = (curNode: any)=> {
}

const filterNodeMethod = (keyword: string, node: any)=> {
  if (!keyword) return true;
  let label = node.label;
  if (label != null) {
    let match = true
    if (!node.filter) {
      match = label.indexOf(keyword) != -1;
    }
    if (match) {
      expandNode(node)
    } else {
      if (Array.isArray(node.children)){
        node.children.forEach((item: any) => {
          item.filter = false
        })
      }
    }
    return match
  } else {
    return false;
  }
}

const expandNode = (node: any) => {
  node.expand = true
  if (Array.isArray(node.children)) {
    node.children.forEach((item: any) => {
      item.filter = true
      expandNode(item)
    })
  }
}
const nodeAdd = (node: any) => {
  if (node.id == null || node.id == '' || node.id == undefined) {
    ElMessage({
      message: '稍等，上一个节点还未添加完成，请过会儿再点击',
      type: 'warning',
    })
    return;
  }
  node.expand = true;
  const level = Number(node.className.substring(5, 6))+1;
  const json = {
    id: null,
    pid: node.id,
    label: '',
    expand: false,
    children: [],
    newNode: true,
    focused: true,
    className : `level${level} clickable`
  }
  debugger
  if (Array.isArray(node.children)) {
    node.children.push(json);
  } else {
    node.children = [json];
  }
  nextTick().then(()=> {
    node.children[node.children.length-1].focused = true;
  });
}
const nodeEdit = (node: any) => {
  node.focused = true;
}
const nodeBlur = (e: any, data: any)=> {
  if (data.label == '' || data.label == null || data.label == undefined) {
    return;
  }
  editPageData('/main/materialLibrary/node/saveOrUpdate', data).then((res)=> {
    data.id = res;
  });
}
const getNodeById: any = (treeNode: any, id: number)=> {
  if (treeNode.id == id) {
    return treeNode
  } else if (Array.isArray(treeNode.children)){
    const list = treeNode.children;
    for (let i=0; i<list.length; i++) {
      const pNode = getNodeById(list[i], id);
      if (pNode) {
        return pNode;
      }
    }
  }
}
const nodeDelete = (node: any, bbb: any, ccc: any)=> {
  ElMessageBox.confirm('确定要删除吗？（<font color="red">将会同时删除所有子分支</font>）',
  '注意',
    {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning',
      dangerouslyUseHTMLString: true
    }
  ).then(()=> {
    if (node.id == '' || node.id == null || node.id == undefined) {
      ElMessage({
        message: '稍等，节点还未添加完成，请过会儿再删除',
        type: 'warning'
      })
      return;
    }
    if (node.id == 1) {
      ElMessage({
        message: '根节点不允许删除',
        type: 'warning'
      })
      return;
    }

    const oldPaNode = getNodeById(nodes.value, node.pid);
    if (oldPaNode) {
      const list = oldPaNode.children;
      for(let i=0, len=list.length; i<len; i++) {
        if (list[i].id == node.id) {
          list.splice(i, 1);
          break;
        }
      }
    }
    deletePageData('/main/materialLibrary/node/'+node.id);
  });
}
const defineMenus = [
  {name: '复制文本', command: 'copy'},
  {name: '新增节点', command: 'add'},
  {name: '编辑节点', command: 'edit'},
  {name: '删除节点', command: 'delete'},
  {name: '————', command: ''},
  {name: '新增描述', command: 'addRemark'},
  {name: '编辑描述', command: 'editRemark'},
  {name: '删除描述', command: 'deleteRemark'}
]

const router = useRouter()

const filter = ()=> {
  treeRef.value.filter(keyword.value);
}
const generate = async (id: string) => {
  debugger
  const url = await getLibraryGenerateUrl(id)
  try {
    await toClipboard(url)
    ElNotification({
      title: '复制成功',
      message: '快去黏贴给客户吧',
      type: 'success'
    })
  } catch (e) {
    ElNotification({
      title: '复制失败',
      message: '请等一会，复制',
      type: 'error'
    })
  }
}

const style = {
  // color: "#ffffff",
};

const isUpdate = usePermission(pageName, 'update');
const isDelete = usePermission(pageName, 'delete');
const isQuery = usePermission(pageName, 'list');
const isCreate = usePermission(pageName, 'create');

const modalTitle = ref('')
const otherInfo = reactive({
  cover: ''
})
const type = ref();

const getTree = () => {
  modalConfig.formItems.splice(0, 1, {
    field: 'types',
    type: 'cascader',
    label: '素材分类',
    options: nodes.value.children,
    placeholder: '请搜索或选择素材分类',
    otherOptions: {
      'show-all-levels': false,
      clearable: true,
      filterable: true,
      props: {
        multiple: true,
        checkStrictly: true,
        value: 'id',
        label: 'name',
        children: 'children',
        emitPath: false
      }
    }
  })
}

const handleMenu = (node: any) => {
  switch (node.command) {
    case 'addRemark':
      addRemark(node.data)
      break;
    case 'editRemark':
      editRemark(node.data)
      break;
    case 'deleteRemark':
      deleteRemark(node.data)
      break
  }
}

const remarkDialogVisible = ref(false);
const remarkInput = ref('');
const nodeRemark = ref()
const addRemark = (node: any) => {
  if (node.remark === undefined || node.remark === null || node.remark === '') {
    remarkInput.value = ''
    nodeRemark.value = node
    remarkDialogVisible.value = true;
  } else {
    ElMessage.warning('该节点已有描述，无需再添加')
  }
}

const editRemark = (node: any) => {
  if (node.remark === undefined || node.remark === null || node.remark === '') {
    ElMessage.warning('该节点没有创建描述，请先添加描述')
  } else {
    remarkInput.value = node.remark
    nodeRemark.value = node
    remarkDialogVisible.value = true
  }
}

const deleteRemark = (node: any) => {
  if (node.remark === undefined || node.remark === null || node.remark === '') {
    ElMessage.warning('该节点没有描述')
  } else {
    node.remark = ''
    const loadingInstance = ElLoading.service({
      lock: true,
      text: '正在删除描述...',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    editPageData('/main/materialLibrary/node/saveOrUpdate', node).then(() => {
      remarkDialogVisible.value = false;
      ElMessage.success('描述删除成功');
    }).catch(() => {
      ElMessage.error('描述删除失败');
    }).finally(() => {
      loadingInstance.close();
    });
  }
}

const confirmAddRemark = () => {
  if (remarkInput.value != '') {
    nodeRemark.value.remark = remarkInput.value
    const loadingInstance = ElLoading.service({
      lock: true,
      text: '正在保存描述...',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    editPageData('/main/materialLibrary/node/saveOrUpdate', nodeRemark.value).then((res) => {
      nodeRemark.value.id = res;
      remarkDialogVisible.value = false;
      ElMessage.success('描述保存成功');
    }).catch(() => {
      ElMessage.error('描述保存失败');
    }).finally(() => {
      loadingInstance.close();
    });
  } else {
    ElMessage.warning('描述不能为空')
  }
}

const renderContent = (h: any, node: any) => {
  return h('div', [
    h('div', {class: 'tree-org-node__text', title: node.$$data.remark}, node.label)
  ]);
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_vue3_tree_org = _resolveComponent("vue3-tree-org")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_input, {
        type: "text",
        modelValue: keyword.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((keyword).value = $event)),
        placeholder: "请输入搜索内容",
        onKeydown: _withKeys(filter, ["enter"]),
        clearable: "",
        style: {"width":"200px"},
        size: "small"
      }, {
        append: _withCtx(() => [
          _createVNode(_component_el_button, {
            icon: "el-icon-search",
            onClick: filter
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_vue3_tree_org, {
        ref_key: "treeRef",
        ref: treeRef,
        data: nodes.value,
        horizontal: true,
        collapsable: true,
        expandAll: true,
        "only-one-node": false,
        "default-expand-level": 2,
        "label-style": style,
        scalable: false,
        toolBar: {scale: true, restore: true, expand: true, zoom: false, fullscreen: true },
        "define-menus": defineMenus,
        onOnNodeBlur: nodeBlur,
        "node-delete": nodeDelete,
        "filter-node-method": filterNodeMethod,
        "node-add": nodeAdd,
        "node-edit": nodeEdit,
        onOnNodeDblclick: nodeDbclick,
        "clone-node-drag": false,
        onOnNodeDragStart: nodeDragStart,
        onOnNodeDrag: nodeDrag,
        onOnNodeDragEnd: nodeDragEnd,
        "node-draggable": draggable.value,
        "before-drag-end": beforeDragEnd,
        onOnContextmenu: handleMenu,
        "render-content": renderContent
      }, null, 8, ["data", "node-draggable"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: remarkDialogVisible.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((remarkDialogVisible).value = $event)),
      title: "节点描述",
      width: "30%"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_3, [
          _createVNode(_component_el_button, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (remarkDialogVisible.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("取 消")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: confirmAddRemark
          }, {
            default: _withCtx(() => [
              _createTextVNode("确 定")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          modelValue: remarkInput.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((remarkInput).value = $event)),
          type: "textarea",
          rows: 4,
          placeholder: "请输入描述内容"
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})